import { useEffect, useRef, useState } from 'react'

const Popover = ({
  trigger,
  content,
  position = 'bottom',
  className = '',
  positionClassname = '',
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const popoverRef = useRef(null)
  const triggerRef = useRef(null)
  const handleClickOutside = (event) => {
    if (
      popoverRef.current &&
      !popoverRef.current.contains(event.target) &&
      !triggerRef.current.contains(event.target)
    ) {
      setIsOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const positionClasses = {
    top: 'bottom-full mb-2',
    bottom: 'top-full mt-2',
    left: 'right-[-30%]',
    right: 'left-full ml-2',
  }

  return (
    <div className={`relative h-full ${className}`}>
      <div
        ref={triggerRef}
        onClick={() => setIsOpen(!isOpen)}
        className='cursor-pointer'
      >
        {trigger}
      </div>
      {isOpen && (
        <div
          ref={popoverRef}
          className={`
            absolute z-10
            ${positionClasses[position]}
            ${positionClassname}
            rounded-lg
            shadow-lg
            p-4
            min-w-[200px]
            animate-in fade-in duration-200
            bg-white
            border-[0.4px] border-[#f4f4f4]
          `}
        >
          <div className='min-h-[300px]'>{content}</div>
        </div>
      )}
    </div>
  )
}

export default Popover
